export default __webpack_public_path__ + "static/saad-cecd576f84127aa3a20189740d8b804f.svg";